import React from "react";
import { Modal, message } from "antd";
import { CopyToClipboard } from "react-copy-to-clipboard";
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  PinterestShareButton,
  TwitterShareButton,
} from "react-share";
import "../../styles/share.scss";
import Facebook from "../../assets/images/icons/facebook.svg";
import Twitter from "../../assets/images/icons/twitter.svg";
import Linkedin from "../../assets/images/icons/linkedin.svg";
import Pinterest from "../../assets/images/icons/pinterest.svg";
import Mail from "../../assets/images/icons/mail.svg";

const Share = ({ url, show, hide, media }) => {
  const link = url ? url : String(window.location.href);

  return (
    <Modal
      className="share-wrapper"
      footer={null}
      title="Share"
      closable={true}
      onCancel={hide}
      open={show}
    >
      <div className="d-flex">
        <FacebookShareButton url={link}>
          <div className="icon cursor-pointer">
            <img className="img" alt="" src={Facebook} />
            <p className="label">facebook</p>
          </div>
        </FacebookShareButton>
        <TwitterShareButton url={link}>
          <div className="icon cursor-pointer">
            <img className="img" alt="" src={Twitter} />
            <p className="label">twitter</p>
          </div>
        </TwitterShareButton>
        <LinkedinShareButton url={link}>
          <div className="icon cursor-pointer">
            <img className="img" alt="" src={Linkedin} />
            <p className="label">LinkedIn</p>
          </div>
        </LinkedinShareButton>
        <PinterestShareButton url={link} media={media}>
          <div className="icon cursor-pointer">
            <img className="img" alt="" src={Pinterest} />
            <p className="label">pinterest</p>
          </div>
        </PinterestShareButton>
        <EmailShareButton url={link} subject={"Dovemed Blogs"} body="">
          <div className="icon cursor-pointer">
            <img className="img" alt="" src={Mail} />
            <p className="label">mail</p>
          </div>
        </EmailShareButton>
      </div>
      <div className="copy-container">
        <div className="cp-child1">
          <span>or copy link:</span>
          <p>{`This is dovemed url-${link}`}</p>
        </div>
        <div className="cp-child2 cursor-pointer">
          <CopyToClipboard
            text={link}
            onCopy={() => {
              message.success("Link copied to clipboard");
              hide();
            }}
          >
            <span>COPY</span>
          </CopyToClipboard>
        </div>
      </div>
    </Modal>
  );
};

export default Share;
